export enum Separator {
	AND = ',',
	RANGE = '-',
	INCREMENT = '/',
	NTH_WEEKDAY_OF_MONTH = '#'
}
